import React from 'react';
import { styles } from './VariantThumbnail.css';

interface VariantIconProps {
  onClick?: (e: React.SyntheticEvent) => void;
  children: React.ReactNode;
  isSelected?: boolean;
}

const handleClick = (e: React.SyntheticEvent, onClick: ((e: React.SyntheticEvent) => void) | undefined) => {
  e.preventDefault();
  e.stopPropagation();
  onClick && onClick(e);
};

export const VariantThumbnail = ({ children, onClick, isSelected }: VariantIconProps) => {
  return (
    <button onClick={e => handleClick(e, onClick)} className={styles.container({ isSelected })}>
      {children}
    </button>
  );
};
